import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import * as React from "react";

export default function NavBar(props) {
  const isMobile = useMediaQuery("(max-width: 700px)");

  const navItems = [
    { label: "About", action: props.scrollToAbout },
    { label: "Certificates", action: props.scrollToCertificates },
    { label: "Projects", action: props.scrollToProjects },
    // { label: "Demos", action: props.scrollToDemos },
    { label: "Contact", action: props.scrollToContact },
  ];

  return (
    <Box
      sx={{
        background: "rgba(14,5,46,0.85)",
        backdropFilter: "blur(24px)",
        WebkitBackdropFilter: "blur(24px)",
        borderBottom: "1px solid rgba(255,131,168,0.85)",
        boxShadow: "0 4px 30px rgba(0,0.85)",
        px: isMobile ? 2 : 5,
        py: isMobile ? 1.5 : 2,
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: isMobile ? "center" : "space-between",
          flexDirection: isMobile ? "column" : "row",
          gap: isMobile ? 1 : 0,
        }}
      >
        <Box>
          <Typography
            component="h2"
            variant={isMobile ? "h4" : "h3"}
            color="secondary"
            sx={{
              fontFamily: "Nickainley",
              // textShadow: "1px 1px 1px rgba(255, 255, 255, 0.25)",
              letterSpacing: "2px",
              lineHeight: 1,
            }}
          >
            Patricia Milou
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {navItems.map((item, i) => (
            <React.Fragment key={item.label}>
              {i > 0 && (
                <Box
                  sx={{
                    height: "18px",
                    width: "1px",
                    backgroundColor: "rgba(255,255,255,0.50)",
                    mx: 0.25,
                  }}
                />
              )}
              <Button
                size="small"
                onClick={item.action}
                sx={{
                  color: "rgba(255,255,255,0.85)",
                  fontFamily: "Roboto",
                  fontWeight: 500,
                  fontSize: isMobile ? "0.68rem" : "0.78rem",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  px: 1.5,
                  py: 0.6,
                  minWidth: 0,
                  borderRadius: "8px",
                  "&:hover": {
                    color: "#FF83A8",
                    background: "rgba(255,131,168,0.10)",
                  },
                  transition: "color 0.2s, background 0.2s",
                }}
              >
                {item.label}
              </Button>
            </React.Fragment>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
